<script lang="ts">
  import { truncate } from '$utils/helpers.util';
  import type { FPost } from 'garden-common';
  import Media from '../common/media/Media.svelte';

  export let post: Partial<FPost<string>> | null = null;

  let details: number = 0;
  let clientWidth: number = 0;
  //Check how many details are filled in
  if (post?.media?.length) {
    for (let i = 0; i < post.media.length; i++) {
      if (post.media[i].images.length > 0 && post.media[i]?.details?.details) {
        for (let j = 0; j < Object.values(post.media[i].details.details).length; j++) {
          let data = Object.values(post.media[i].details.details)[j] as any;

          if (data) {
            for (let t = 0; t < data.length; t++) {
              if (!data[t]) continue;
              details += 1;
            }
          }
        }
      }
    }
  }

  let img_src: string;

  function update_img_src() {
    if (!post?.media?.[0]?.thumbnails?.[0]) {
      return;
    }

    if (typeof post?.media?.[0]?.thumbnails?.[0] === 'string') {
      img_src = post?.media?.[0]?.thumbnails?.[0];
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(post?.media?.[0]?.thumbnails?.[0]);
      reader.onload = () => {
        img_src = reader.result as string;
      };
    }
  }

  $: post, update_img_src();
</script>

<div class="border border-blueish-grey-200 rounded-2xl p-4">
  <div
    role="button"
    tabindex="0"
    class="flex flex-row gap-5 justify-start"
    on:keydown
    on:click={() => {}}
  >
    <!-- src="https://api.dicebear.com/5.x/identicon/svg?seed=$Test&backgroundColor=ffffff" -->
    <div
      class="aspect-square overflow-hidden rounded-lg h-[95.5px] w-[95.5px] flex-shrink-0 bg-gray-100"
    >
      {#if img_src}
        <Media src={img_src} autoplay={false} alt="" class="object-cover w-full h-full" />
      {/if}
    </div>

    <div class="flex flex-col text-left justify-between w-full h-full gap-3">
      <div class="flex flex-col text-left justify-center">
        <span class="text-grey-transparency-dark text-lg font-bold"> {post?.title || 'N/A'} </span>
        <span class="text-grey-transparency-dark-56 truncate -z[100] font-medium">
          {truncate(post?.description, 30) || 'N/A'}
        </span>
      </div>

      <div class="w-full flex flex-row gap-6">
        <div class="flex flex-col gap-[2px]">
          <span class="text-grey-transparency-dark font-medium">{details}</span>
          <span class="text-grey-transparency-dark-56 text-sm font-medium">Details</span>
        </div>
        <div class="flex flex-col gap-[2px]">
          <span class="text-grey-transparency-dark font-medium">{post?.media?.length}</span>
          <span class="text-grey-transparency-dark-56 text-sm font-medium">File</span>
        </div>
        <div class="w-full flex flex-col gap-[2px]" bind:clientWidth>
          <span class="w-full text-grey-transparency-dark font-medium">
            {truncate(`${post?.category}/${post?.subcategories?.[0]}`.trim(), clientWidth / 9)}
          </span>
          <span class="text-grey-transparency-dark-56 text-sm font-medium">Category</span>
        </div>
      </div>
    </div>
  </div>
</div>
